import { ConfirmationModal } from '@folio/stripes/components';
import React from 'react';
import { t } from '../../services';
export var ConfirmDeleteModal = function (_a) {
    var listName = _a.listName, onConfirm = _a.onConfirm, onCancel = _a.onCancel, open = _a.open;
    return (React.createElement(ConfirmationModal, { buttonStyle: "danger", confirmLabel: t('list.modal.delete'), heading: t('list.modal.delete-list'), message: t('list.modal.confirm-message', { listName: listName }), onCancel: onCancel, onConfirm: onConfirm, open: open }));
};
